import { BontonPanel } from './../../../../environments/bonton-panel';
import { DateTime } from 'luxon';
import { Router } from '@angular/router';
import { Component, ElementRef, HostListener, ViewChild } from '@angular/core';
import { NgClass, AsyncPipe, DatePipe, CommonModule } from '@angular/common';
import { FormBuilder, FormGroup, FormsModule, ReactiveFormsModule } from '@angular/forms';
import { ReplaySubject, Subject, debounceTime, distinctUntilChanged, filter, startWith, switchMap, takeUntil } from 'rxjs';
import { RoomsAndGuestsComponent } from '../rooms-and-guests/rooms-and-guests.component';
import { CacheService } from 'app/services/cache.service';
import { MatButtonModule } from '@angular/material/button';
import { MatDatepickerModule } from '@angular/material/datepicker';
import { MatDialog, MatDialogModule } from '@angular/material/dialog';
import { MatIconModule } from '@angular/material/icon';
import { MatInputModule } from '@angular/material/input';
import { MatSelect, MatSelectModule } from '@angular/material/select';
import { NgxMatSelectSearchModule } from 'ngx-mat-select-search';
import { HotelService } from 'app/services/hotel.service';
import { SlickCarouselModule } from 'ngx-slick-carousel';
import { DateAdapter, MAT_DATE_FORMATS } from '@angular/material/core';
import { LuxonDateAdapterService } from 'app/services/LuxonDateAdapter.service';
import { CommonUtils, MY_DATE_FORMATS } from 'app/utils/commonutils';
import { ToasterService } from 'app/services/toaster.service';
import { SettingsService } from 'app/services/settings.service';
import { themes } from 'app/utils/const';
import { ValidationService } from 'app/services/validation.service';
import { VideoHelpService } from 'app/services/VideoHelp.service';

@Component({
    selector: 'app-hotels-main',
    templateUrl: './main.component.html',
    standalone: true,
    imports: [
        NgClass,
        AsyncPipe,
        DatePipe,
        CommonModule,
        FormsModule,
        ReactiveFormsModule,
        MatIconModule,
        MatButtonModule,
        MatInputModule,
        MatSelectModule,
        MatDialogModule,
        MatDatepickerModule,
        NgxMatSelectSearchModule,
        SlickCarouselModule,
        RoomsAndGuestsComponent
    ],
    providers: [
        { provide: DateAdapter, useClass: LuxonDateAdapterService },
        { provide: MAT_DATE_FORMATS, useValue: MY_DATE_FORMATS },
    ],
})
export class MainComponent {
    @ViewChild('destinationSelect') destinationSelect: MatSelect;
    @ViewChild('starsSelect') starsSelect: MatSelect;
    @ViewChild('roomAndGuestRef', { static: false }) roomAndGuestRef: ElementRef;
    @ViewChild('containerRef', { static: false }) containerRef: ElementRef;
    @ViewChild('roomsAndGuestsDropdown', { static: false }) roomsAndGuestsDropdown: ElementRef;

    guestPopAbove: boolean = false;
    bontonPanel: any = BontonPanel;
    formGroup: FormGroup;
    destinationList: ReplaySubject<any[]> = new ReplaySubject<any[]>();
    minDate = new Date();
    roomData: any = {};
    alldestinationList: any[] = [];
    themes = themes;
    selectedField: string = ''
    starList: any[] =
        [
            { value: '1', viewValue: '1' },
            { value: '2', viewValue: '2' },
            { value: '3', viewValue: '3' },
            { value: '4', viewValue: '4' },
            { value: '5', viewValue: '5' },
        ];

    slideConfig = {
        arrows: false,
        slidesToShow: 1,
        slidesToScroll: 5,
        dots: true,
        infinite: false,
        autoplay: false,
        autoplaySpeed: 3000,
        variableWidth: true,
        centerMode: false,
        margin: 10,
    };

    slideConfig1 = {
        arrows: false,
        slidesToShow: 1,
        slidesToScroll: 5,
        dots: true,
        infinite: false,
        autoplay: false,
        autoplaySpeed: 3000,
        variableWidth: true,
        centerMode: false,
        margin: 10,
    };

    PopularRecordsList: any;
    recentHotelSearchList: any[] = [];
    destination: any[];
    outmindate: Date = new Date();
    settings: any = {};
    _unsubscribeAll: Subject<any> = new Subject<any>();
    wlSettingsDetails: any = {};
    hotelData: any = {};
    isOpenRoomsGuests: boolean;
    isFirstDest: boolean = true;
    isRiyaHotel: boolean = false;
    searchDestinationText: string = '';
    isFirstService: boolean = CommonUtils.getB2COrderByUrl() === 'hotels';
    is_mobile = CommonUtils.isMobile;
    is_tablet = CommonUtils.isTablet;

    constructor(
        private router: Router,
        private builder: FormBuilder,
        private hotelService: HotelService,
        private matDialog: MatDialog,
        private settingService: SettingsService,
        private cacheService: CacheService,
        private alertService: ToasterService,
        private validationService: ValidationService,
        private videoHelpService: VideoHelpService
    ) {
        this.settingService.settings.pipe(takeUntil(this._unsubscribeAll)).subscribe(settings => {
            this.settings = settings;
            this.wlSettingsDetails = settings;
            // console.log("wlSetting = ", this.wlSettingsDetails);
            this.hotelData = this.wlSettingsDetails?.service_search_sections?.find(x => x.section_for.toLowerCase() == "hotel");
            this.settingService.updateSeoPageMeta('hotels'); // Seo Page Meta Details Updates
        });

    }
    /**
     * Angular lifecycle hook called after component initialization.
     * Initializes form controls, date bounds, subscriptions, and initial data fetches
     * such as recent searches and popular records.
     * @returns void
     */
    ngOnInit(): void {
        let currentDate: Date = new Date();
        this.outmindate.setDate(currentDate.getDate() + 1);
        this.formGroup = this.builder.group({
            destination: [''],
            checkin: [DateTime.fromJSDate(new Date()).toFormat('yyyy-MM-dd')],
            checkout: [DateTime.fromJSDate(new Date()).plus({ days: 1 }).toFormat('yyyy-MM-dd')],
            adult: [1],
            child: [0],
            room: [1],
            guest: [2],
            stars: [''],
            destinationfilter: [''],
            destination_name: [''],
            nationality: [''],
            nationalityfilter: ['']
        });
        if (this.bontonPanel.isB2B()) {
            this.getRecentHotelSearch();
        }
        this.getPopularRecords();

        const oldJSON = JSON.parse(localStorage.getItem('hotels-filters') || null);

        this.formGroup.get('destinationfilter').valueChanges
            .pipe(
                filter(search => !!search),
                startWith(''),
                debounceTime(400),
                distinctUntilChanged(),
                switchMap((value: any) => {
                    this.searchDestinationText = value || '';
                    return this.hotelService.getHotelCityCombo(this.isFirstDest && !oldJSON?.destination ? '' : value);
                })
            )
            .subscribe(data => {
                this.destinationList.next(data);
                this.alldestinationList = data;
                if (!oldJSON) {
                    this.formGroup.get('stars').setValue(['1', '2', '3', '4', '5']);
                    this.roomData = {
                        rooms: 1,
                        totaladult: 2,
                        totalchild: 0,
                        child_ages: [],
                    };
                    if (this.isFirstDest) {
                        this.formGroup.get('destination').patchValue(this.alldestinationList[0]);
                        this.isFirstDest = false;
                    }
                }
            });

        if (oldJSON) {
            this.isFirstDest = false;
            if (new Date(oldJSON.checkin) < new Date()) {
                oldJSON.checkin = DateTime.fromJSDate(new Date()).toFormat('yyyy-MM-dd')
            }
            if (new Date(oldJSON.checkout) < new Date()) {
                oldJSON.checkout = DateTime.fromJSDate(new Date()).toFormat('yyyy-MM-dd')
            }
            var checkin = new Date(oldJSON.checkin);
            checkin.setDate(checkin.getDate() + 1);
            this.outmindate = checkin;
            this.formGroup.get('destinationfilter').patchValue((oldJSON?.destination?.city_name || ''));
            this.formGroup.patchValue(oldJSON);
            this.roomData = oldJSON.rooms;
        }


    }

    /**
     * Handle clicks anywhere in the document to close open dropdowns when clicking outside.
     * @param event - MouseEvent from the document click
     * @returns void
     */
    @HostListener('document:click', ['$event'])
    onDocumentClick(event: MouseEvent) {
        if (!this.selectedField) return;
        // Check if the clicked element is inside the component's host element.
        const target = event.target as Node;
        if (this.containerRef && !this.containerRef.nativeElement.contains(target)) {
            this.selectedField = '';
        }
    }

    /**
     * Toggle the guest selection dropdown open/closed and adjust its position for non-B2B views.
     * @returns void
     */
    openGuest() {
        this.selectedField ? this.selectedField = '' : this.selectedField = 'guest';
        if (!this.bontonPanel.isB2B()) {
            setTimeout(() => {
                this.checkDropdownPosition()
            }, 0);
        }
    }

    /**
     * Calculate whether the rooms & guests dropdown should open above or below the field
     * based on available viewport space and the dropdown element height.
     * @returns void
     */
    checkDropdownPosition() {
        if (!this.containerRef || !this.roomsAndGuestsDropdown) {
            return;
        }
        // Get the position of the "Guest" field and the viewport
        const guestRect = this.containerRef.nativeElement.getBoundingClientRect();
        const dropdownHeight = this.roomsAndGuestsDropdown.nativeElement.offsetHeight;
        const viewportHeight = window.innerHeight;

        // Calculate the space available below the field
        const spaceBelow = viewportHeight - guestRect.bottom + 100;
        // Check if there's enough space below
        if (spaceBelow < dropdownHeight) {
            // Not enough space, so open above
            this.guestPopAbove = true;
        } else {
            // Enough space, open below
            this.guestPopAbove = false;
        }
    }

    /**
     * Comparison function used by mat-select to determine selected option equality.
     * @param v1 - first value to compare (typically an option object)
     * @param v2 - second value to compare (typically the model value)
     * @returns boolean - true if values are considered equal
     */
    public compareWith(v1: any, v2: any) {
        return (v1 && v2 && v1?.id == v2?.id);
    }

    /**
     * Handle changes to the check-in date. Ensures checkout is always at least one day after checkin
     * and updates the outmindate boundary accordingly.
     * @param v - the new check-in date (any type accepted, typically a Date or date-string)
     * @returns void
     */
    changeDate(v: any) {
        const checkoutDate = DateTime.fromJSDate(new Date(this.formGroup.get('checkout').value)).toFormat('yyyy-MM-dd');
        const checkinDate = DateTime.fromJSDate(new Date(this.formGroup.get('checkin').value)).toFormat('yyyy-MM-dd');
        if (checkinDate > checkoutDate || checkinDate === checkoutDate) {
            const AfterDate = DateTime.fromJSDate(new Date(v)).plus({ days: 1 }).toFormat('yyyy-MM-dd');
            this.formGroup.get('checkout').patchValue(AfterDate)
        }
        this.outmindate = new Date(v);
        this.outmindate.setDate(this.outmindate.getDate() + 1);
    }

    /**
     * Fetches recent hotel search records and stores them locally for display.
     * @returns void
     */
    getRecentHotelSearch() {
        this.hotelService.getRecentSearchRecords().subscribe((res: any) => {
            this.recentHotelSearchList = res;
        });
    }

    /**
     * Wrapper to initiate a recent search flow by marking the input value and delegating to detail().
     * @param val - the recent search record object
     * @returns void
     */
    recentSearch(val: any): void {
        val.text = 'recentSearch';
        this.detail(val);
    }

    /**
     * Wrapper to initiate a popular-record search flow by marking the input value and delegating to detail().
     * @param val - the popular record object
     * @returns void
     */
    popular(val: any): void {
        val.text = 'popular';
        this.detail(val);
    }

    /**
     * Fetches popular hotel records and sets local state including supplier flag.
     * @returns void
     */
    getPopularRecords() {
        this.hotelService.getPopularRecords().subscribe((res: any) => {
            this.PopularRecordsList = res;
            this.isRiyaHotel = res.isRiyaSupplier;
        });
    }

    /**
     * Filters city results based on a provided value and passes the matched city to callback.
     * @param value - object containing destination and destination_id used to filter remote results
     * @param callback - optional callback invoked after destination is set
     * @returns void
     */
    filtercity(value: any, callback?: () => void) {
        this.hotelService.getHotelCityCombo(value.destination).subscribe({
            next: (res) => {
                const dcity = res.filter(x => x.id === value.destination_id || x.city_name.toLowerCase() == value.destination.toLowerCase())
                this.destination = dcity;
                callback();
            }
        })
    }

    /**
     * Primary search handler. Validates selection state, prepares filter JSON from the form
     * and navigates to the hotel results or details page. Handles recent and popular shortcuts.
     * @param val - optional object indicating a recent/popular shortcut and its associated data
     * @returns void
     */
    detail(val?: any): void {
        if (this.isOpenRoomsGuests) {
            this.alertService.showToast('error', 'Please Apply the room and guest selection');
            return;
        }
        const json = this.formGroup.getRawValue();
        json.checkin = DateTime.fromJSDate(new Date(json.checkin)).toFormat('yyyy-MM-dd');
        json.checkout = DateTime.fromJSDate(new Date(json.checkout)).toFormat('yyyy-MM-dd');
        json.rooms = this.roomData;

        this.cacheService.MainFilterChanged(this.isRiyaHotel, 'NewHotelDesign');
        if (json.stars.length < 1 && !val) {
            this.alertService.showToast('error', 'Please Fill up all the field.')
            return;
        } else {
            if (json.stars.length < 1 && val) {
                json.stars = ["1", "2", "3", "4", "5"];
            }
        }
        if (val?.text === 'recentSearch') {
            this.filtercity(val, () => {
                json.stars = val.star.split(',').map(star => star.trim());
                let guest = val.newRooms.totaladult + val.newRooms.totalchild;

                json.rooms = val.newRooms;
                json.checkin = DateTime.fromJSDate(new Date(val.checkin)).toFormat('yyyy-MM-dd');
                json.checkout = DateTime.fromJSDate(new Date(val.checkout)).toFormat('yyyy-MM-dd');
                json.guest = guest;
                json.destination = this.destination != undefined && this.destination != null && this.destination.length > 0 ? this.destination[0] : val.destination;
                json.destinationfilter = '';
                json.room = val.newRooms.rooms;

                this.cacheService.MainFilterChanged(json, 'hotels-filters');
                this.createNavigateURL(json);
            });
        } else if (val?.text === 'popular') {
            this.filtercity(val, () => {
                json.destination = this.destination[0];
                json.destinationfilter = '';

                this.cacheService.MainFilterChanged(json, 'hotels-filters');
                this.createNavigateURL(json);
            });


        } else {
            this.cacheService.MainFilterChanged(json, 'hotels-filters');
            this.createNavigateURL(json);
        }
    }

    /**
     * Builds and triggers navigation to a hotel details route using the provided filter JSON.
     * Performs validation on the destination name and formats the URL segments.
     * @param json - filter JSON object containing destination, checkin, checkout and other params
     * @returns void
     */
    createNavigateURL(json: any): void {
        let desitnation = json.destination.name;
        let isValidSpecialCharacter = this.validationService.checkValidHotelName(desitnation);
        if (isValidSpecialCharacter) {
            if (desitnation.includes('-')) {
                desitnation = this.validationService.replaceDashedWithDoubleUnderscore(desitnation);
            }
            desitnation = desitnation.replace(',', '');
            let navigateStr = '/hotels/details/' + desitnation + '/' + json.checkin + '/' + json.checkout;
            navigateStr = this.validationService.replaceSpaceToHyphen(navigateStr);
            this.router.navigate([navigateStr]);
        }
        else {
            this.router.navigate(['/hotels/details'])
        }
    }

    /**
     * Opens a new browser window/tab with the provided URL.
     * @param str - URL to open in a new window
     * @returns void
     */
    openNewWindow(str: string) {
        window.open(str, '_blank')
    }

    /**
     * Opens the rooms & guests modal if it is not already open.
     * @returns void
     */
    roomsAndGuest(): void {
        if (!this.isOpenRoomsGuests) {
            this.openRoomAndGuestModel(false);
        }
    }

    /**
     * Opens the RoomsAndGuests dialog/modal with positioning appropriate for mobile or desktop.
     * After the dialog closes the room and guest selections are applied to the form.
     * @param flag - unused flag parameter (kept for API compatibility)
     * @returns void
     */
    openRoomAndGuestModel(flag: any) {
        this.isOpenRoomsGuests = true;
        const ismobile = this.is_mobile();
        const istablet = this.is_tablet();

        let rect: any = {}
        let dialogPosition = {}
        let dialogWidth = "";
        let obj = {}

        if (!ismobile && !istablet) {
            rect = this.roomAndGuestRef.nativeElement.getBoundingClientRect();
            dialogPosition = {
                top: `${rect.bottom + 5}px`,
                left: `${rect.left}px`
            };

            if (this.bontonPanel.isB2B()) {
                dialogWidth = `${rect.width}px`
            } else {
                dialogWidth = `${rect.width + rect.width / 4}px`
            }

            obj = {
                data: { data: this.formGroup.value, roomdata: this.roomData },
                width: dialogWidth,
                position: dialogPosition,
                hasBackdrop: true,
                disableClose: false,
                backdropClass: 'bg-transparent',
                enterAnimationDuration: '0ms',
                exitAnimationDuration: '0ms',
            }
        } else {
            obj = {
                data: { data: this.formGroup.value, roomdata: this.roomData },
                panelClass: ismobile ? 'full-screen-model' : 'remove-dialog-pading',
                width: '480px',
                hasBackdrop: true,
                disableClose: true,
            }
        }

        if (ismobile || istablet) {
            this.matDialog
                .open(RoomsAndGuestsComponent, obj)
                .afterClosed()
                .subscribe({
                    next: (res) => {
                        this.isOpenRoomsGuests = false;
                        if (res) {
                            this.formGroup.patchValue({
                                guest: res.guest,
                                room: res.allVal,
                            });

                            this.roomData = res.roomDataList;
                        }
                    }
                });
        }
    }

    /**
     * Applies returned pax data (rooms/guests) to the form and updates local roomData.
     * @param data - object returned from RoomsAndGuests component containing guest and room values
     * @returns void
     */
    patchPaxData(data: any) {
        if (data) {
            this.formGroup.patchValue({
                guest: data.guest,
                room: data.allVal,
            });

            this.roomData = data.roomDataList;
        }
        this.selectedField = '';
    }


    /**
     * Programmatically opens the destination select dropdown.
     * @returns void
     */
    // Open To Destination Dropdown
    openToCityDropdown() {
        this.destinationSelect.open();
    }


    /**
     * Programmatically opens the stars select dropdown.
     * @returns void
     */
    // On Star Select Dropdown
    openToStarDropdown() {
        this.starsSelect.open();
    }


    /**
     * Angular lifecycle hook called when component is destroyed.
     * Used to clean up subscriptions and other resources.
     * @returns void
     */
    ngOnDestroy(): void {
        this._unsubscribeAll.next(null);
        this._unsubscribeAll.complete();
    }


    /**
     * Highlights the search term within a given text using the validation service.
     * @param text - the source text in which to highlight matches
     * @param search - the search term to highlight
     * @returns string - HTML string with highlighted search matches
     */
    highlightSearch(text: string, search: string): string {
        return this.validationService.highlightSearch(text, search);
    }


    /**
     * Returns the city name of the currently selected destination from the form.
     * @returns string - the selected city's name or an empty string if not available
     */
    getCityName() {
        return this.formGroup.get('destination')?.value?.city || '';
    }

    helpVideo(sectionName: string) {
        this.videoHelpService.helpVideo(sectionName);
    }
}
